/**
* Left Right Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'left-right-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.left-right-banner' ).each( function( key, val ) {
        const badgeRing = $( this ).find( '.kcstrong-badge .text-ring' )[0];
        const height = $( this ).outerHeight();

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top top',
              end: 'bottom top',
              scrub: 0,
            },
          } );
          tl.to( badgeRing, {rotate: '360deg', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right-banner', COMPONENT );
} )( app );
